import * as React from 'react';
import { Box } from '../box';

type CardProps = any & {
    variantColor?: 'light' | 'dark';
};

const Card: React.FC<CardProps> = (props: CardProps): React.ReactElement => (
    <Box rounded={['lg', null, null, 'xl']} p={[3, null, null, 4]} {...props} />
);

export default Card;
